module.exports = __webpack_public_path__ + "img/participant-select-desktop-fr.f1674cdd.jpg";